import { Component } from '@angular/core';

@Component({
  selector: 'app-official-permissions',
  standalone: true,
  imports: [],
  templateUrl: './official-permissions.component.html',
  styleUrl: './official-permissions.component.css'
})
export class OfficialPermissionsComponent {

}
